// Machine Spare Parts catalog (SRDP 560, SRDP 780, Hammer Mill)
// Prices stored as SOURCE reference (INR). Discounted price = src * (1 - DISCOUNT).
// Use "ASK" for parts without a fixed rate.

export const SPARE_DISCOUNT = 0.03; // 3% off across the board

export const applyDiscount = (src) => {
  if (!src || src === "ASK") return "ASK";
  return Math.round(src * (1 - SPARE_DISCOUNT));
};

export const formatPrice = (src) => {
  const p = applyDiscount(src);
  if (p === "ASK") return "Ask for Price";
  return `₹${p.toLocaleString("en-IN")}`;
};

// Category images — generic stock (safe to use). Replace anytime via admin.
export const CATEGORY_META = {
  SRDP_560: {
    key: "SRDP_560",
    title: "SRDP 560 Spare Parts",
    subtitle: "Vertical Ring Die Pellet Machine — 560 model",
    image: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=800&q=70",
    accent: "emerald",
  },
  SRDP_780: {
    key: "SRDP_780",
    title: "SRDP 780 Spare Parts",
    subtitle: "Heavy-Duty Vertical Ring Die Pellet Machine — 780 model",
    image: "https://images.unsplash.com/photo-1565043666747-69f6646db940?auto=format&fit=crop&w=800&q=70",
    accent: "amber",
  },
  HAMMER_MILL: {
    key: "HAMMER_MILL",
    title: "Hammer Mill Spare Parts",
    subtitle: "For G2400, G3600, THM & HMX models",
    image: "https://images.unsplash.com/photo-1518709594023-6eab9bab7b23?auto=format&fit=crop&w=800&q=70",
    accent: "sky",
  },
};

// ============ SRDP 560 (77 parts) ============
export const SRDP_560 = [
  { name: "Ring Die Height-195mm (SS X46CR13) 8/10/12/14mm", src: 75500 },
  { name: "Ring Die Height-195mm (SS X46CR13) 6 mm", src: 80000 },
  { name: "Ring Die Height-205mm (SS X46CR13) 6mm", src: "ASK" },
  { name: "Ring Die Height-205mm (SS X46CR13) 8/10/12/14mm", src: "ASK" },
  { name: "Ring Die Alloy Steel 205mm (20CRMNTI) 8/10/12/14mm", src: "ASK" },
  { name: "Ring Die Alloy Steel Height-195mm (20CRMNTI) 8/10/12/14mm", src: 46500 },
  { name: "Roller Assembly Complete Set (Teeth Head Type)", src: 17850 },
  { name: "Roller Assembly Complete Set (Welded Type)", src: 22000 },
  { name: "Roller Shell (Teeth Head Type) 20CrMnTi", src: 5500 },
  { name: "Roller Shell (Welded Type)", src: 9000 },
  { name: "Rubber Ring (1 m)", src: 180 },
  { name: "Roller Bearing (Good Quality) 33120#", src: 1950 },
  { name: "Roller Bearing (High Quality) 33120#", src: 3250 },
  { name: "Roller Oil Seal (Red High Temperature)", src: 230 },
  { name: "Roller Acentric Shaft (With Hardened Spline)", src: 4650 },
  { name: "Roller Acentric Shaft (Regular Type)", src: "ASK" },
  { name: "Roller Upper Flange", src: 580 },
  { name: "Roller Downside Flange", src: "ASK" },
  { name: "Roller Downside Flange (Wear Resistance Material)", src: 1530 },
  { name: "Maze Wear Ring - Upper", src: 6000 },
  { name: "Maze Wear Ring - Down", src: 6000 },
  { name: "Adjuster", src: 2200 },
  { name: "Adjuster Setting Bolt", src: 1750 },
  { name: "Adjuster Setting Bolt Lock", src: 1050 },
  { name: "Roller Shaft Check Nut", src: 175 },
  { name: "Die Clamp / Die Lock", src: 1800 },
  { name: "RM Cutting Knife", src: 1600 },
  { name: "Automatic Grease Pump (2 / 3 / 4)", src: 44500 },
  { name: "Grease Pipe Small (1 Pc)", src: 260 },
  { name: "Grease Pipe Small L-Type (1 Pc)", src: 260 },
  { name: "Grease Pipe Big (1 Pc)", src: 380 },
  { name: "Main Shaft Upper Side Bearing (#23140) HQ", src: 36500 },
  { name: "Main Shaft Down Side Bearing (#32238) HQ", src: 30250 },
  { name: "Oil Pressure Meter", src: 6650 },
  { name: "Rotary Joint", src: 14500 },
  { name: "Star Rubber", src: 900 },
  { name: "Star Rubber (Petal Type)", src: 900 },
  { name: "Main Motor Couple Joint", src: 24500 },
  { name: "Spline - Joint Type", src: 18500 },
  { name: "Soft Starter Device 160 Kw", src: 73500 },
  { name: "Soft Starter Device 132 Kw", src: 70000 },
  { name: "Radiator Small", src: 21500 },
  { name: "Radiator Big", src: 26500 },
  { name: "Oil Pipe (1 pc)", src: 680 },
  { name: "Oil Flow Check Glass", src: 1950 },
  { name: "Oil Filter Plug with Oil Filter (Complete Set)", src: 2500 },
  { name: "Oil Filter (80mm)", src: 400 },
  { name: "Oil Filter (85mm)", src: 400 },
  { name: "Oil Filter (90mm)", src: 400 },
  { name: "Dial Motor + Gear set", src: 22800 },
  { name: "Sirclip (Small)", src: 30 },
  { name: "Dust Collector Bag (Bag Only)", src: 800 },
  { name: "Bearing Pressure Cone", src: 200 },
  { name: "Roller Flap (1 Pc)", src: 800 },
  { name: "i-Bolt (M16)", src: 160 },
  { name: "D shackle", src: 125 },
  { name: "D shackle (SS)", src: 200 },
  { name: "Roller Shell Inner Spacer", src: 190 },
  { name: "Main Shaft", src: 96500 },
  { name: "Main Shaft Housing", src: 310000 },
  { name: "Gear Reducer", src: 595000 },
  { name: "Motor Coupler", src: 24500 },
  { name: "Grease Bucket (18Kg)", src: 5650 },
  { name: "Grease Barrel (180 Kg)", src: 56500 },
  { name: "4 Bag Compact Dust Collector", src: 30500 },
  { name: "Raw Material Moisture Meter", src: "ASK" },
  { name: "12x25 CSK Bolt", src: 16 },
  { name: "Roller Shaft Key", src: 20 },
  { name: "Roller Flange Bolt 8x25 LN Key", src: 16 },
  { name: "Grease Bolt 24 x 40", src: 110 },
  { name: "Benjo Bolt 10mm", src: 22 },
  { name: "Benjo Bolt 12mm", src: 27 },
  { name: "Grease Nipple", src: 45 },
  { name: "Roller Cup Bush 560 (Up) (Hardened)", src: 860 },
  { name: "Roller Cup Bush 560 (Down) (Hardened)", src: 860 },
  { name: "Die Clamp Bolt HT — 20 X 150", src: 140 },
  { name: "Oil Pump With Motor", src: 15500 },
  { name: "Oil Pump", src: 3800 },
  { name: "Oil Pump Coupler", src: 1550 },
  { name: "4 Bag Dust Blower Without Motor", src: 20500 },
  { name: "4 Bag Dust Collector With Motor", src: 37500 },
  { name: "Check Nut BIG", src: 1700 },
  { name: "By Pass Contactor (132KW)", src: 14200 },
  { name: "By Pass Contactor (160KW)", src: 19000 },
  { name: "Bearing 33024", src: 3650 },
  { name: "Bearing 32220", src: 3750 },
  { name: "Bearing 32226", src: 4700 },
  { name: "Bearing #32036", src: 8850 },
  { name: "560P Cutter Gear Ring", src: 48500 },
  { name: "Cutter Gear Box", src: 26000 },
  { name: "#1 Shaft with Gear", src: 32250 },
  { name: "#2 Shaft Only", src: 31800 },
  { name: "#3 Shaft Only", src: 58500 },
  { name: "#4 Shaft Only", src: 39800 },
  { name: "#5 Gear Only", src: 36500 },
  { name: "#6 Gear Only", src: 74500 },
  { name: "#7 Gear Only", src: 98500 },
];

// ============ SRDP 780 (26 parts) ============
export const SRDP_780 = [
  { name: "Ring Die (SS X46CR13) 8/10/12/14mm", src: 149350 },
  { name: "Ring Die (SS X46CR13) 6 MM", src: 155000 },
  { name: "Ring Die Alloy Steel (20CRMNTI) 8/10/12/14mm", src: 88000 },
  { name: "Ring Die Alloy Steel (20CRMNTI) 6mm", src: 98000 },
  { name: "Roller Assembly Complete Set (Teeth Head Type)", src: 43500 },
  { name: "Bit Roller Assembly Complete Set (Welded Type)", src: 48750 },
  { name: "Roller Shell (Teeth Head Type) 20CrMnTi", src: 10000 },
  { name: "Roller Shell (Welded Type)", src: 18000 },
  { name: "Roller Bearing 32224# (High Quality)", src: 3250 },
  { name: "Roller Oil Seal", src: 450 },
  { name: "Roller Acentric Shaft", src: 11000 },
  { name: "Roller Upper Flange", src: 1950 },
  { name: "Roller Downside Flange (Wear Resistance Material)", src: 2150 },
  { name: "Maze Wear Ring Set (Male + Female)", src: 22000 },
  { name: "Bearing Pressure Cone", src: 430 },
  { name: "Roller Flap (1 Pc)", src: 980 },
  { name: "Roller Cup Bush (Up)", src: 1050 },
  { name: "Roller Cup Bush (Down)", src: 950 },
  { name: "Sirclip (Small)", src: 95 },
  { name: "Bearing 33024", src: 3650 },
  { name: "Bearing 32220", src: 3750 },
  { name: "Bearing 32226", src: 4700 },
  { name: "Bearing 32044", src: 13850 },
  { name: "Bearing 32038", src: 9995 },
  { name: "By Pass Contactor (200KW)", src: 22500 },
  { name: "Soft Starter Device 200 Kw", src: 92000 },
];

// ============ HAMMER MILL (52 parts) ============
export const HAMMER_MILL = [
  { name: "Bitter (G2400)", src: 140 },
  { name: "Bitter (G3600)", src: 400 },
  { name: "Turbo Hammer Bitter (THM90 / THM120 / THM140)", src: 630 },
  { name: "HMX 4T/3T Bitter (Hard Welded)", src: 550 },
  { name: "HMX 4T/3T Bitter (8mm — Special Steel)", src: 485 },
  { name: "HMX 5T Bitter", src: 790 },
  { name: "Bitter Rod (G2400)", src: 130 },
  { name: "Bitter Rod (G3600)", src: 280 },
  { name: "HMX 3T Bitter Rod (20mm)", src: 300 },
  { name: "HMX 4T Bitter Rod (20mm)", src: 390 },
  { name: "HMX 5T Bitter Rod (25mm)", src: 750 },
  { name: "Screen 6mm / 8mm (G2400)", src: 1600 },
  { name: "Screen 6mm / 8mm (G3600)", src: 5375 },
  { name: "Turbo Hammer Screen THM90 (8mm Thickness)", src: 9000 },
  { name: "Turbo Hammer Screen THM90 (4mm Thickness)", src: 3000 },
  { name: "Turbo Hammer Screen THM140 8/10mm (4mm Thickness)", src: 8900 },
  { name: "Turbo Hammer Screen THM140 8/10mm (8mm Thickness)", src: 13900 },
  { name: "Turbo Hammer Screen THM140 14/16mm", src: 13900 },
  { name: "HMX 3T Screen", src: 11500 },
  { name: "HMX 4T Screen", src: 14950 },
  { name: "HMX 5T Screen", src: 24200 },
  { name: "Liner Plate (G2400)", src: 6695 },
  { name: "Liner Plate (G3600)", src: 12565 },
  { name: "Hammer Mill Vibration Pad (G2400)", src: 900 },
  { name: "Hammer Mill Vibration Pad (G3600)", src: 900 },
  { name: "Blower Vibration Pad (G2400)", src: 465 },
  { name: "Blower Rotor 15HP", src: 16950 },
  { name: "Blower Rotor 20HP", src: 17850 },
  { name: "Blower Rotor 25HP", src: 21500 },
  { name: "Blower Rotor 30HP", src: 29000 },
  { name: "Blower Rotor 40HP", src: 39500 },
  { name: "Airlock Leather 12\"", src: 150 },
  { name: "Airlock Leather 15\"", src: 185 },
  { name: "Airlock Leather 18\"", src: 255 },
  { name: "HMX 3T Rotor Set", src: 235000 },
  { name: "HMX 4T Rotor Set", src: 278800 },
  { name: "HMX 5T Rotor Set", src: 390000 },
  { name: "V-Belt (C165)", src: 875 },
  { name: "Clamp Small", src: 410 },
  { name: "Clamp Big", src: 570 },
  { name: "Pillow Pedestal S-614", src: 3750 },
  { name: "Pillow Pedestal S-618", src: 7400 },
  { name: "HMX 4T Bearing Pedestal", src: 15850 },
  { name: "HMX 3T Bearing Pedestal", src: 14500 },
  { name: "HMX 5T Bearing Pedestal", src: 19000 },
  { name: "NTN-Bearing 22314 (G-2400)", src: 6500 },
  { name: "Pedestal P-204", src: 130 },
  { name: "Pedestal P-208", src: 315 },
  { name: "Pedestal T-208", src: 600 },
  { name: "Pedestal F-211", src: 580 },
  { name: "Pedestal F-209", src: 400 },
  { name: "Double Side Bitter (G2400)", src: 245 },
  { name: "Double Side Bitter (G3600)", src: 275 },
  { name: "220 Teeth Bitter (G2400)", src: 415 },
  { name: "220 Teeth Bitter (G3600)", src: 585 },
  { name: "NTN-Bearing 22320 (G-3600)", src: 18400 },
  { name: "NBC-Bearing 22318 (THM90/120/140)", src: 12000 },
  { name: "NTN-Bearing 22316 (HMX 4T/3T)", src: 10300 },
  { name: "NTN-Bearing 22224 (HMX 5T)", src: 16400 },
  { name: "Liner Plate (HMX 4T)", src: 900 },
  { name: "Shredder Blade (2212)", src: 9950 },
  { name: "Shredder Blade (2210)", src: 9550 },
];

const slugify = (s, prefix) =>
  `${prefix}-${s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "").slice(0, 60)}`;

const enrich = (arr, model) =>
  arr.map((p, i) => ({
    id: slugify(p.name, model.toLowerCase().replace(/[^a-z0-9]/g, "-")) + "-" + i,
    name: p.name,
    src: p.src,
    price: formatPrice(p.src),
    model,
    category: model,
  }));

export const ALL_SPARES = {
  SRDP_560: enrich(SRDP_560, "SRDP 560"),
  SRDP_780: enrich(SRDP_780, "SRDP 780"),
  HAMMER_MILL: enrich(HAMMER_MILL, "Hammer Mill"),
};

export const SPARE_CATEGORIES = [
  { ...CATEGORY_META.SRDP_560, items: ALL_SPARES.SRDP_560 },
  { ...CATEGORY_META.SRDP_780, items: ALL_SPARES.SRDP_780 },
  { ...CATEGORY_META.HAMMER_MILL, items: ALL_SPARES.HAMMER_MILL },
];
